import WarningTrianglePath from "@ingka/ssr-icon/paths/warning-triangle";

export default WarningTrianglePath;
